import { useEffect, useRef, useState } from "react";
import { FaTrash } from "react-icons/fa"
import DeleteItem from "../../utils/DeleteItem"
import HandleUpdateText from "../../utils/HandleUpdateText";
import { FormatDateString, FormatDateTimeString, FormatDateToDDMMYYHHMM } from "../../utils/FormatDate";
import HandleUpdateSelect from "../../utils/HandleUpdateSelect";
import { BACKEND } from "../../config/configEnvs";
import axios from "axios";
import { toast } from "react-toastify";
import { Checkbox, debounce, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from "@mui/material";
import { GetStatusColor } from "../../utils/GetTextColor";
import DeleteButton from "../ui/components/DeleteButton";

const ItemRowEvent = ({event, setEvents, workers, services, user}) => {

  const debounceUpdate = useRef(null); // Referencia para mantener el debouncer

  const initialState = useRef(event.serviceInterest ? event.serviceInterest?.map((s) => s.id) : []);
  
  const [interestServicesSelected, setInterestServicesSelected] = useState(
    event.serviceInterest ? event.serviceInterest?.map((s) => s.id) : []
  );

  const isEditable = 
    event.eventType !== "Llamada" && 
    event.eventType !== "Entrada al sistema" && 
    event.eventType !== "Cambio estado cotización"

  const handleUpdateInterestServices = async (newValues) => {
    try {
      const response = await axios.put(`${BACKEND}/api/eventosLeads/${event.id}`, {
        serviceInterest: newValues
      })
      
    } catch (e) {
      toast.error("Error al actualizar el dato: " + e)
    }
  }
  
  useEffect(() => {
    if (JSON.stringify(initialState.current) === JSON.stringify(interestServicesSelected)) {
      return; // No ejecutar si el estado no ha cambiado respecto al inicial
    }
  
    if (debounceUpdate.current) {
      clearTimeout(debounceUpdate.current);
    }
  
    debounceUpdate.current = setTimeout(() => {
      handleUpdateInterestServices(interestServicesSelected);
    }, 1000);
  
    return () => clearTimeout(debounceUpdate.current); 
  
  }, [interestServicesSelected]); 

  const handleDeleteEvent = async (eventId, isLast) => {

    try {
      await axios.delete(`${BACKEND}/api/eventosLeads/${eventId}`);
  
      if (isLast) {
        // Buscar el evento anterior más reciente
        const { data: previousEvent } = await axios.get(
          `${BACKEND}/api/eventosLeads?where[lead][equals]=${event.lead.id}&sort=-createdAt&limit=1`
        );
  
        if (previousEvent.docs.length > 0) {
          await axios.patch(`${BACKEND}/api/eventosLeads/${previousEvent.docs[0].id}`, {
            isLast: true,
          });
        }
      }
  
      setEvents((p) => p.filter((e) => e.id !== event.id))
  
      toast.success("Evento eliminado correctamente");
    } catch (error) {
      console.error("Error al eliminar el evento:", error);
      toast.error("Error al eliminar el evento");
    }
  };

  // Manejar cambios en la selección
  const handleInterestServicesChange = (event) => {
    setInterestServicesSelected(event.target.value); // Recibe un array de IDs
  };

  const ITEM_HEIGHT = 48;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 6.5,
        width: 200,
      },
    },
  };

  const ColorMap = {
    "Lead": "text-yellow-500",
    "Prospecto": "text-blue-500",
    "Cliente": "text-green-500",
  }

  return (
    <tr className="text-xs py-2 w-full hover:bg-gray-100 transition-all duration-100">
      {user.area.toUpperCase() === "ADMINISTRACION" && (
        <td className="px-6 py-4 truncate border border-gray-300 text-center">
          <DeleteButton
            action={() => handleDeleteEvent(event.id, event.isLast)}
            content="Eliminar evento"
          />
        </td>
      )}
      <td className="px-6 py-4 truncate border border-gray-300 text-center">
        {FormatDateTimeString(event.createdAt)}
      </td>
      <td className="px-4 py-2 truncate border border-gray-300 text-center">
        {event.lead.leadName}
      </td>
      <td className="px-4 py-2 border border-gray-300 min-w-[250px] text-center">
        <span className="text-gray-500">{event.title}</span>
      </td>
      <td className="px-4 py-2 border border-gray-300 min-w-[250px] text-center">
        <span className="text-gray-500">{event.description}</span>
      </td>
      <td className="px-4 py-2 border border-gray-300 min-w-[150px] text-center">
        <span className="text-gray-500">{event.seller?.name}</span>
      </td>
      <td className={`px-4 py-2 border border-gray-300 min-w-[150px] text-center`}>
        <span className={`${GetStatusColor(event.leadStatus, ColorMap)}`}>
          {event.leadStatus}
        </span>
      </td>
      <td className="px-4 py-2 truncate border border-gray-300 min-w-[200px] text-center">
        <span className="text-gray-500">                          
          {event.eventType ? (event.eventType === "Google Meet" ? "Registro de meet en el sistema" : event.eventType + (event.eventType === "Entrada al sistema" ? ` \n (${event.lead.entryOrigin})` : "")) : "No definido"}
        </span>
      </td>   
      <td className="px-4 py-2 border min-w-[250px] border-gray-300 text-center">
        <span className="text-gray-500">{event.eventSubType}</span>
      </td>
      <td className={`px-4 py-2 border min-w-[250px] border-gray-300 text-center ${event.scheduledDate ? "text-black" : "text-gray-200"}`}>
        {event.scheduledDate ? FormatDateTimeString(event.scheduledDate) : "No aplica"}
      </td>
      {/* <td className="px-2 truncate border min-w-[200px] border-gray-300 text-center">
        {event.eventType === "Google Meet" ? (
          <input 
            type="date" 
            className="text-gray-700 w-full hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
            value={event.rescheduledDate ? new Date(event.rescheduledDate).toISOString().split("T")[0] : ""}
            onChange={(e) => HandleUpdateText("rescheduledDate", e.target.value, event.id, "eventosLeads", debounceUpdate, setEvents)}
          />
        ) : (
          <span className="text-gray-200">No reagenda</span>
        )}
      </td> */}
      <td className="px-2 truncate border min-w-[250px] border-gray-300 text-center">
        {event.eventType === "Google Meet" ? (
          <input 
            type="text"
            placeholder="Link del meet"
            value={event.eventLink}
            className="text-xs w-full text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
            onChange={(e) => HandleUpdateText("eventLink", e.target.value, event.id, "eventosLeads", debounceUpdate, setEvents)}
          />
        ) : (
          <span className="text-gray-200">No aplica</span>
        )}
      </td>
      <td className={`${event.quote ? "text-black" : "text-gray-200"} px-2 truncate border border-gray-300 min-w-[250px] text-center`}>
        {event.quote ? event.quote.id : "No aplica"}
      </td>
      <td className="px-2 truncate border border-gray-300 min-w-[300px] text-center">
        <FormControl sx={{ zIndex: 1, borderRadius: "8px", width: "100%", height: 32, backgroundColor: "white" }}>
          <InputLabel
            sx={{
              fontSize: 12,
              transform: "translate(14px, 6.5px) scale(1)",
              "&.MuiInputLabel-shrink": {
                transform: "translate(14px, -6px) scale(0.75)",
              },
            }}
          >
            Servicios de interés
          </InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            sx={{
              height: 32,
              display: "flex",
              alignItems: "center",
              fontSize: 12,
              borderRadius: "8px",
            }}
            id="demo-multiple-checkbox"
            multiple
            value={interestServicesSelected}
            onChange={handleInterestServicesChange}
            input={<OutlinedInput label="Servicios de interés" sx={{ height: 25, fontSize: 12 }}/>}
            renderValue={(selected) =>
              services
                .filter((s) => selected.includes(s.id))
                .map((s) => s.name)
                .join(", ")
            }
            MenuProps={MenuProps}
          >
            {services.map((s) => (
              <MenuItem key={s.id} value={s.id} sx={{ height: "30px" }}>
                <Checkbox checked={interestServicesSelected.includes(s.id)} /> 
                <ListItemText primary={s.name} primaryTypographyProps={{ fontSize: 12, fontFamily: "poppins" }}/>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </td>
    </tr>
  )
}

export default ItemRowEvent